import React from 'react';
import subscriptionDiscountImage from '../../assets/3mf-header-banner.svg';
import SuccessTile from './SuccessTile';
import Configuration from '../../common/Configuration.json';

export const subscriptionDiscountDescription = `To say thanks for joining Skinny Broadband your first ${
  Configuration.subscriptionDiscount.durationString
  } are on us!`;
const SubscriptionDiscountSuccessTile = () => <SuccessTile
  image={subscriptionDiscountImage}
  title="A nice freebie for you"
  message={subscriptionDiscountDescription}
/>;


export default SubscriptionDiscountSuccessTile;



/** WEBPACK FOOTER **
 ** ./src/components/Success/SubscriptionDiscountSuccessTile.js
 **/